import { defineStore } from 'pinia'
import { store } from '@/store'

const useCommonStore = defineStore('tmv-common', {
  state: () => ({
    isMuted: true
  }),
  actions: {
    CLOSE_MUTED() {
      this.isMuted = false
    }
  }
})

export function useCommonStoreHook() {
  // 此处放一些使用 store 的额外操作
  // ...
  return useCommonStore(store)
}
